import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';

import {
    MODAL_TYPE_ADBLOCKER,
    MODAL_TYPE_INFORMATIVE,
    MODAL_TYPE_INTERSTITIEL,
    MODAL_TYPE_LOGIN
} from '../../../services/modal/constants';
import { PATH } from '../../../constants/path';
import { TIMER_MS_INTERSTITIEL } from '../../../constants';
import { COOKIE_KEY_REDIRECT_AFTER_LOGIN } from '../../../constants/cookie';

import {
    fetchPartnerDiscountsIfNeeded,
    fetchPartnerMostDisplayableDiscountForUser
} from '../../../services/discount/actions';
import { showModal } from '../../../services/modal/actions';
import { doRewriteUrl } from '../../../services/interstitiel/actions';
import { fetchPartnerCouponsIfNeeded } from '../../../services/coupon/actions';
import { fetchPartnerDetailsIfNeeded } from '../../../services/partner/actions';

import { reformUrlExterieur } from '../../../utils';
import { isTokenExpired } from '../../../services/authentication/utils';

import './InterstitielComponent.scss';

class InterstitielComponent extends React.Component {
    constructor(props) {
        super(props);
        const locationParsed = queryString.parse(props.location.search);
        const isToolbarRequest = props.location.pathname.toLowerCase().includes('toolbar');
        this.state = {
            partnerId: props.match.params.partnerId,
            couponId: props.match.params.couponId ? props.match.params.couponId : '-1',
            clickSource: props.match.params.clickSource,
            urlSource: locationParsed.urlSource ? locationParsed.urlSource : '',
            username: props.match.params.username,
            toolbarRequest: isToolbarRequest,
            isInformativeModalUnderstood: false
        };
    }

    showModal = props =>
        this.props.showModal(MODAL_TYPE_INTERSTITIEL, {
            ...props,
            hideCloseButton: false,
            redirectOnClose: true
        });

    showLoginModal = () => {
        const { MUST_BE_LOGGED_IN, isAuthenticated, showModal } = this.props;
        if (!isAuthenticated) {
            showModal(MODAL_TYPE_LOGIN, {
                dynamicText: MUST_BE_LOGGED_IN
            });
        }
    };

    showAdBlockerModal = props =>
        this.props.showModal(MODAL_TYPE_ADBLOCKER, { ...props, hideCloseButton: true });

    showInformativeModal = props =>
        this.props.showModal(MODAL_TYPE_INFORMATIVE, {
            ...props,
            hideCloseButton: true,
            onConfirm: () => {
                this.setState({ isInformativeModalUnderstood: true });
            }
        });

    renderIframe = () => {
        const { urlRewritten } = this.props;
        return (
            !this.isAdblockerDetectedOrCookiesDisabled() &&
            !this.isInformativeModalRequired() &&
            urlRewritten && (
                <iframe
                    title="interstitiel"
                    src={reformUrlExterieur(urlRewritten)}
                    height="100%"
                    width="100%"
                />
            )
        );
    };

    redirect = url => {
        if (url) {
            console.log('Will be redirect in 5 seconds to', url);

            setTimeout(() => {
                window.location = url;
            }, TIMER_MS_INTERSTITIEL);
        } else {
            console.error('An error occured, no redirection');
        }
    };

    redirectToPartnerWithFailureRetag = () => {
        const { partner } = this.props;
        const { partnerId, couponId } = this.state;

        if (this.isAdblockerDetectedOrCookiesDisabled() || this.isInformativeModalRequired()) {
            return;
        }

        if (partner) {
            console.warn('Retaggage failure, handle user redirect without tag...');
            if (partner.url) {
                this.showModal({
                    success: false,
                    partnerId,
                    couponId,
                    noRedirectionFailure: false
                });
                this.redirect(partner.url);
            } else {
                this.showModal({ success: false, partnerId, couponId, noRedirectionFailure: true });
                this.redirect(PATH.HOME_PATH);
            }
        } else {
            console.warn('Partner cannot be null ! Abort redirect operation.');
        }
    };

    redirectToPartnerWithSuccessRetag = response => {
        const { partner } = this.props;
        const { partnerId, couponId } = this.state;
        let success = false;
        let noRedirectionFailure = false;
        let redirectToUrl = null;

        if (this.isAdblockerDetectedOrCookiesDisabled() || this.isInformativeModalRequired()) {
            return;
        }

        if (response && response.payload.urlRewritten) {
            success = true;
            redirectToUrl = response.payload.urlRewritten;
        } else if (partner && partner.url) {
            redirectToUrl = partner.url;
            console.warn('URL rewritten is missing to redirect the user');
        } else {
            noRedirectionFailure = true;
        }

        this.showModal({ success, noRedirectionFailure, partnerId, couponId, redirectToUrl });
        this.redirect(redirectToUrl);
    };

    isMemberAuthenticated = () =>
        !isTokenExpired(this.props.authentication.token) &&
        this.props.authentication.isAuthenticated;

    isAdblockerDetectedOrCookiesDisabled = () =>
        this.props.adBlockerDetected || !this.props.cookiesEnabled;

    isInformativeModalRequired = () => !this.state.isInformativeModalUnderstood;

    getEffectiveUsername() {
        const { username } = this.state;

        let effectiveUsername = username;

        if (!this.isMemberAuthenticated() && !effectiveUsername) {
            if (!document.cookie) {
                return;
            }

            let cookies = document.cookie.split(';');
            let usernameCookie = cookies.find(val => val && val.includes('Pseudo='));

            if (usernameCookie) {
                // User is recognized - extract cookie value & continue with normal execution
                effectiveUsername = usernameCookie.split('=')[1];
            } else {
                return;
            }
        }

        return effectiveUsername;
    }

    componentDidMount() {
        const {
            fetchPartnerCouponsIfNeeded,
            fetchPartnerDiscountsIfNeeded,
            fetchPartnerDetailsIfNeeded,
            fetchPartnerMostDisplayableDiscountForUser
        } = this.props;
        const { partnerId, couponId } = this.state;

        let effectiveUsername = this.getEffectiveUsername();

        // check effectiveUsername to be sure we are in toolbar scenario (and in email scenario)
        if (!this.isMemberAuthenticated() && !effectiveUsername) {
            sessionStorage.setItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN, this.props.location.pathname);

            this.showLoginModal();
            return;
        }

        fetchPartnerCouponsIfNeeded(partnerId);
        fetchPartnerDiscountsIfNeeded(partnerId);
        fetchPartnerDetailsIfNeeded(partnerId, false);

        if (!this.isMemberAuthenticated() && effectiveUsername) {
            fetchPartnerMostDisplayableDiscountForUser(partnerId, effectiveUsername);
        }

        this.showModal({ partnerId, couponId });
    }

    componentDidUpdate() {
        const {
            doRewriteUrl,
            fetchingUrlRewritten,
            errorUrlRewritten,
            urlRewritten,
            adBlockerDetected,
            cookiesEnabled
        } = this.props;
        const { partnerId, couponId, clickSource, urlSource, toolbarRequest } = this.state;

        let effectiveUsername = this.getEffectiveUsername();

        if (
            !fetchingUrlRewritten &&
            !urlRewritten &&
            !errorUrlRewritten &&
            adBlockerDetected !== true &&
            cookiesEnabled != null &&
            !this.isInformativeModalRequired()
        ) {
            // Call API to rewerite URL.
            doRewriteUrl(
                partnerId,
                couponId,
                clickSource,
                urlSource,
                effectiveUsername,
                toolbarRequest,
                this.isAdblockerDetectedOrCookiesDisabled(),
                this.redirectToPartnerWithSuccessRetag,
                this.redirectToPartnerWithFailureRetag
            );
        }
    }

    render() {
        const { urlRewritten } = this.props;

        if (
            (this.isMemberAuthenticated() || this.getEffectiveUsername()) &&
            this.isAdblockerDetectedOrCookiesDisabled()
        ) {
            this.showAdBlockerModal({ urlRewritten });
        }

        if (
            (this.isMemberAuthenticated() || this.getEffectiveUsername()) &&
            this.isInformativeModalRequired()
        ) {
            this.showInformativeModal();
        }

        return <main id="p-interstitiel">{this.renderIframe()}</main>;
    }
}

InterstitielComponent.propTypes = {
    partner: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
    const partnerId = props.match.params.partnerId;
    return {
        MUST_BE_LOGGED_IN: state.i18n.page.LOGIN.MUST_BE_LOGGED_IN,
        authentication: state.authentication,
        partner: state.partner.partners[partnerId] || {},
        fetchingUrlRewritten: state.interstitiel.fetching,
        errorUrlRewritten: state.interstitiel.error,
        urlRewritten: state.interstitiel.urlRewritten,
        adBlockerDetected: state.adblocker.adBlockerDetected,
        cookiesEnabled: state.adblocker.cookiesEnabled
    };
};

const mapDispatchToProps = {
    doRewriteUrl,
    showModal,
    fetchPartnerCouponsIfNeeded,
    fetchPartnerDiscountsIfNeeded,
    fetchPartnerMostDisplayableDiscountForUser,
    fetchPartnerDetailsIfNeeded
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InterstitielComponent));



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/InterstitielComponent.js